import { Container } from 'pixi.js';
import { Ellipse } from '../../../element-editor/shape/shapes/primitive/ellipse-element';
import { PathElement } from '../../../element-editor/shape/shapes/primitive/path-element';
import { RectangleElement } from '../../../element-editor/shape/shapes/primitive/rectangle-element';
import { TextElement } from '../../../element-editor/shape/shapes/primitive/text-element';
import { Coords } from '../../../elements/resource/types/shape.type';
import { BASE_BLUE } from '../canvas.service';
import { STORYBOARD_GAP, StoryBoardController } from './story-board-controller';
import { setSelectedStoryBoardItem } from '../../../element-editor/store/editor.actions';

export interface StoryBoardItemDescriptor {
  id: number;
  color?: string;
  notes: string[];
}

export class StoryBoardItem {
  container: Container;
  rectangle: RectangleElement;
  addButton: StoryBoardAddButton;
  text: TextElement;
  prev: StoryBoardItem;
  next: StoryBoardItem;

  get id() {
    return this.descriptor.id;
  }
  get cs() {
    return this.controller.cs;
  }
  get rootShape() {
    return this.controller.rootShape;
  }

  constructor(
    private readonly controller: StoryBoardController,
    public descriptor: StoryBoardItemDescriptor,
    public index: number,
  ) {
    const [x, y, width, height] = this.controller.getOffset(index);

    this.container = new Container();
    this.container.setTransform(x, y);

    this.rootShape.rootContainer.addChildAt(this.container, 0);

    this.rectangle = new RectangleElement(
      this,
      this.container,
      {
        x,
        y,
        width,
        height,
        fill: this.descriptor.color || '#ffffff',
        'fill-opacity': this.descriptor.color ? 1 : 0.0001,
        stroke: BASE_BLUE,
        'stroke-width': 2,
        // This makes possible to put shapes onto the story-board
        noDrag: true,
      },
      0,
    )
      .mouseover(() => {
        document.documentElement.style.cursor = 'pointer';
        this.rectangle.patch({
          'stroke-width': 3,
        });
      })
      .mouseout(() => {
        document.documentElement.style.cursor = 'auto';
        this.rectangle.element.filters = [];
        this.rectangle.patch({
          'stroke-width': 2,
        });
      });
    // .click(() => {
    //   // console.log('click - sbe');
    //   this.controller.store.dispatch(
    //     setSelectedStoryBoardItem({ id: this.descriptor.id }),
    //   );

    //   const [x] = this.getOffset();
    //   // console.log('story-board-item > click', -x);
    //   this.cs.fitCanvas(-x);
    //   // -- //
    // });

    this.addButton = new StoryBoardAddButton(this, [x + width, y + height / 2]);

    return;
    this.text = new TextElement(this, this.container, {
      x: 2,
      y: -20,
      text: `${this.index + 1} / ${this.controller.descriptor.items.length}`,
      fontSize: 400,
      fill: BASE_BLUE,
    });
  }

  click() {}

  updatePosition() {
    // I need to
    const [x, y] = this.controller.getOffset(this.index);
    this.container.setTransform(x, y);
    this.cs.generalEventEmit(`story-board-update-${this.id}`, [x, y]);
  }

  getOffset() {
    return this.controller.getOffset(this.index);
  }

  doesContainPoint(x0: number, y0: number) {
    const [x, y, w, h] = this.controller.getOffset(this.index);
    if (x <= x0 && x0 <= x + w && y <= y0 && y0 <= y + h) {
      return [x, y];
    }
  }

  zoomUpdate() {
    // -- //
    // TODO - update slide index text, and add button
  }

  shiftRight() {
    this.index++;
    this.controller.items[this.index] = this;
    this.updatePosition();
    this.next?.shiftRight();
  }

  addNext() {
    // -- // -- // --
    this.controller.addNext(this);
  }

  delete() {
    this.text?.remove();
    this.addButton?.remove();
    this.rectangle.remove();
  }
}

const circleRadius = 10;
const circlePadding = 4;

export class StoryBoardAddButton {
  circle: Ellipse;
  path1: PathElement;
  path2: PathElement;

  get rootShape() {
    return this.storyBoardItem.rootShape;
  }

  constructor(
    private readonly storyBoardItem: StoryBoardItem,
    offset: Coords,
  ) {
    const [x, y] = offset;

    const ox = STORYBOARD_GAP / 2;
    this.circle = new Ellipse(
      this.storyBoardItem,
      this.rootShape.rootContainer,
      {
        position: {
          x: x + ox,
          y,
        },
        x: x + ox,
        y,
        rx: circleRadius,
        ry: circleRadius,
        stroke: BASE_BLUE,
        fill: BASE_BLUE,
        'fill-opacity': 0.001,
        'stroke-width': 1.5,
      },
    )
      .click(() => {
        this.storyBoardItem.addNext();
      })
      .mouseover(() => {
        // -- // -- // -- // -- // -- // -- //

        this.circle.patch({
          'stroke-width': 1.5,
        });
        this.path1.patch({
          'stroke-width': 1.5,
        });
        this.path2.patch({
          'stroke-width': 1.5,
        });
        document.documentElement.style.cursor = 'pointer';
      })
      .mouseout(() => {
        this.circle.patch({
          'stroke-width': 1,
        });
        this.path1.patch({
          'stroke-width': 1,
        });
        this.path2.patch({
          'stroke-width': 1,
        });
        document.documentElement.style.cursor = 'auto';
      });

    this.path1 = new PathElement(
      this.storyBoardItem,
      this.rootShape.rootContainer,
      {
        stroke: BASE_BLUE,
        'stroke-width': 1,
        position: {
          x: x + ox,
          y: y - circleRadius + circlePadding,
        },
        elements: [
          {
            type: 'line',
            x: 0,
            y: 2 * circleRadius - 2 * circlePadding,
          },
        ],
      },
    );

    this.path2 = new PathElement(
      this.storyBoardItem,
      this.rootShape.rootContainer,
      {
        stroke: BASE_BLUE,
        position: {
          x: x + (STORYBOARD_GAP - 2 * circleRadius) / 2 + circlePadding,
          y: y,
        },
        elements: [
          {
            type: 'line',
            x: 2 * circleRadius - 2 * circlePadding,
            y: 0,
          },
        ],
      },
    );
  }

  remove() {
    this.circle.remove();
    this.path1.remove();
    this.path2.remove();
  }
}
